export default __webpack_public_path__ + "static/media/random10.74efd5f2.jpeg";